import {
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { Language, SupportedLanguages } from "./supported-languages";

import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const Internationalization = () => {
  const { i18n } = useTranslation();
  const languageList = useMemo(
    () => SupportedLanguages.filter((lang) => lang.hasInternationalization),
    []
  );

  const handleLanguageChange = async (language: Language) => {
    await i18n.changeLanguage(language.key);
  };

  return (
    <DropdownMenuContent align="end">
      {languageList.map((language) => {
        return (
          <DropdownMenuItem
            key={language.key}
            onClick={() => void handleLanguageChange(language)}
          >
            {language.label} - {language.key.toUpperCase()}
          </DropdownMenuItem>
        );
      })}
    </DropdownMenuContent>
  );
};
